/**
 * Service Bus - API Tracking
 * GET/POST /api/v1/bus/ , GET/PUT/PATCH/DELETE /api/v1/bus/{id}/
 */
import { createTrackingClient } from "../trackingApi";

export interface TrackingBus {
  id: string;
  name: string;
  plate_number: string;
  driver_id: number | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface BusUpsertPayload {
  name: string;
  plate_number: string;
  driver_id?: number | null;
  is_active?: boolean;
}

function getClient(accessToken: string | undefined) {
  return createTrackingClient(accessToken);
}

export async function fetchTrackingBus(
  accessToken: string | undefined
): Promise<TrackingBus[]> {
  const client = getClient(accessToken);
  const { data } = await client.get<TrackingBus[] | { results: TrackingBus[] }>("/api/v1/bus/");
  if (Array.isArray(data)) return data;
  if (data && typeof data === "object" && "results" in data) return (data as { results: TrackingBus[] }).results;
  return [];
}

export async function createTrackingBus(
  accessToken: string | undefined,
  payload: BusUpsertPayload
): Promise<TrackingBus> {
  const client = getClient(accessToken);
  const { data } = await client.post<TrackingBus>("/api/v1/bus/", payload);
  return data;
}

export async function updateTrackingBus(
  accessToken: string | undefined,
  id: string,
  payload: BusUpsertPayload
): Promise<TrackingBus> {
  const client = getClient(accessToken);
  const { data } = await client.put<TrackingBus>(`/api/v1/bus/${id}/`, payload);
  return data;
}

export async function deleteTrackingBus(
  accessToken: string | undefined,
  id: string
): Promise<void> {
  const client = getClient(accessToken);
  await client.delete(`/api/v1/bus/${id}/`);
}
